import axios from '@/libs/api.request'

/**
 * 集团项目列表
 */
export const groupItemList = (group_id) => {
    const data ={
        "group_id": group_id
    }
    return axios.request({
        url: '/api/admin/projectgroupitem/list',
        data,
        method: 'post'
    })
}

/**
 * 集团项目列表
 */
export const delGroupItem = (ids) => {
    const data ={
        "ids": ids
    }
    return axios.request({
        url: '/api/admin/projectgroupitem/del',
        data,
        method: 'post'
    })
}

/**
 * 集团列表
 */
export const allGroup = () => {
    return axios.request({
        url: '/api/admin/projectgroup/allGroup',
        method: 'post'
    })
}